module.exports = {
  theme: 'dark', // dark light 导航主题颜色
  layout: 'head', // side head //导航方式side-》侧边 head-》头部
  systemName: '报修管理系统', // 导航标题
  fixedHeader: true, // 是否固定头部
  fixSiderbar: true, // 是否固定导航
  copyright: '芜湖技术中心',
  multipage: false
}
